export const subtitles = {
    "1": {
        "startTime": 7.42,
        "endTime": 12.12,
        "transcript": "Kitak' ciumek atren qanrutkeqerru Yugcetun, allrakun-llu.",
        "translation": "First, please say your Yup'ik name and your age."
    },
    "2": {
        "startTime": 13.465,
        "endTime": 18.475,
        "transcript": "Wiinga waniwa Kuigilngurmiunguunga.",
        "translation": "I am from Kwigillingok."
    },
    "3": {
        "startTime": 18.765,
        "endTime": 24.015,
        "transcript": "Atqa-wa Yugcetun Miisaq. Miisarmek pituatnga",
        "translation": "My Yup'ik name is Miisaq. They call me Miisaq"
    },
    "4": {
        "startTime": 24.255,
        "endTime": 29.605,
        "transcript": "Kass'atun-llu Milton M. Lewis.",
        "translation": "And in English, Milton M. Lewis."
    },
    "5": {
        "startTime": 30.075,
        "endTime": 32.575,
        "transcript": "Qangvaq nani-llu yuurtellruluten?",
        "translation": "When and where were you born?"
    },
    "6": {
        "startTime": 32.65,
        "endTime": 37.48,
        "transcript": "Kuigilngurmi yuurtellruunga. Kuigilngurmi yuurtellruunga.",
        "translation": "I was born in Kwigillingok. I was born in Kwigillingok."
    },
    "7": {
        "startTime": 37.48,
        "endTime": 39.2,
        "transcript": "Qaillun maa-i allrakungluten?",
        "translation": "How old are you now?"
    },
    "8": {
        "startTime": 39.205,
        "endTime": 47.315,
        "transcript": "Maa-i certificate-aaqa Juneau-mek tekitelleq aturluku allrakunka 74-aarurtut.",
        "translation": "Going by my [birth] certificate that came from Juneau, I am 74 years old."
    },
    "9": {
        "startTime": 48.195,
        "endTime": 55.015,
        "transcript": "Kitak' ciumek qanrutkeqerr' qaillun ellangeqarraallerpeni Quyayaralallruciitnek.",
        "translation": "First, please talk about how they celebrated Thanksgiving when you were growing up."
    },
    "10": {
        "startTime": 55.28,
        "endTime": 65.34,
        "transcript": "Imumi tang tan'gaurluulua ellangeqarraallemni au͡gkut angullrenka yuut Quyayaramek nallullrulriit.",
        "translation": "You see, when I was growing up as a boy, the people that I was born in time to see didn't know about Thanksgiving."
    },
    "11": {
        "startTime": 65.605,
        "endTime": 70.44,
        "transcript": "Tua-i Quyayarartaunani maaten ellangua.",
        "translation": "I grew up without Thanksgiving."
    },
    "12": {
        "startTime": 70.44,
        "endTime": 82.72,
        "transcript": "Nutaan tau͡gaam makunek Kuigilngurmek pinek wani, agayulirteńek pingqelangamta",
        "translation": "Only when we started having, you know, priests in Kwigillingok"
    },
    "13": {
        "startTime": 82.725,
        "endTime": 86.465,
        "transcript": "Nutaan Quyayaraq tamaani tamakut nasvallruat.",
        "translation": "That's when they first shared Thanksgiving."
    },
    "14": {
        "startTime": 88.75,
        "endTime": 91.45,
        "transcript": "Qaillun Quyayaratuluteng ayagniqarraallermeggni?",
        "translation": "How did they celebrate Thanksgiving in the beginning?"
    },
    "15": {
        "startTime": 91.455,
        "endTime": 98.705,
        "transcript": "When they first started, when they about how it first started",
        "translation": "When they first started, when they about how it first started"
    },
    "16": {
        "startTime": 98.925,
        "endTime": 103.815,
        "transcript": "Agayulirtet iliita, Didmer-aam pingatellrua",
        "translation": "One of the priests, I think it was Didmer"
    },
    "17": {
        "startTime": 104.595,
        "endTime": 112.425,
        "transcript": "Taukut-gguq teguarullret imarpiim akianek nani akmani yaaqvani",
        "translation": "They said that those who were captives from across the ocean, somewhere far away"
    },
    "18": {
        "startTime": 112.785,
        "endTime": 116.96,
        "transcript": "Teguarullermeggnek imarpik qerarluku.",
        "translation": "In their captivity, they crossed the ocean."
    },
    "19": {
        "startTime": 116.96,
        "endTime": 123.76,
        "transcript": "Imumek iciw' teguat makut, teguarulriit assiliqapiarluteng piyuilnguut.",
        "translation": "You know, those who are captives do not live very comfortably."
    },
    "20": {
        "startTime": 124.015,
        "endTime": 127.145,
        "transcript": "Arenqiallugtaarluteng pillruut.",
        "translation": "They kept getting into unfortunate circumstanes."
    },
    "21": {
        "startTime": 127.145,
        "endTime": 131.145,
        "transcript": "Tua-i-llu imarpik tamana qerarluku.",
        "translation": "Then they crossed the ocean."
    },
    "22": {
        "startTime": 131.94,
        "endTime": 139.27,
        "transcript": "Cavkenateng tuc'ameng tamaani nutaan naucetaanek ayagnirluteng.",
        "translation": "When they landed safely, they then planted crops."
    },
    "23": {
        "startTime": 140.28,
        "endTime": 146.25,
        "transcript": "Tamakut naucetaat ayagnilteng piluku.",
        "translation": "They [harvesteed] those crops they started."
    },
    "24": {
        "startTime": 146.25,
        "endTime": 150.63,
        "transcript": "Nutaan Quyayaraq tamana man'a maa-i ayagnillrulliniat.",
        "translation": "That is when they started this Thanksgiving celebration."
    },
    "25": {
        "startTime": 150.635,
        "endTime": 159.705,
        "transcript": "Agayutmun iciw' aulukucirteng tamaani-llu qaillun teguarullermeggni nangteqellrung'e'rmeng cakneq.",
        "translation": "You know, how God took care of them even though they greatly sufferen in captivity."
    },
    "26": {
        "startTime": 160.555,
        "endTime": 168.205,
        "transcript": "Tamakunek tamaa-i naucetaanek-ll' arcaqerluteng naugillermeggnek Agayutem nauvkallrinek",
        "translation": "Escpecially those crops that they grew, that God allowed to grow"
    },
    "27": {
        "startTime": 168.205,
        "endTime": 174.705,
        "transcript": "Neqkameggnek quyaluteng man'a maa-i Quyayaraq ayagnillruat nutaan.",
        "translation": "Out of gratitude for their food, they started this Thanksgiving celebration."
    },
    "28": {
        "startTime": 175.3,
        "endTime": 180.07,
        "transcript": "During Thanksgiving, what kinds of traditional wisdom or admonishments would you hear?",
        "translation": "During Thanksgiving, what kinds of traditional wisdom or admonishments would you hear?"
    },
    "29": {
        "startTime": 183.78,
        "endTime": 184.94,
        "transcript": "Kitak' nutaan.",
        "translation": "Now you may start."
    },
    "30": {
        "startTime": 184.945,
        "endTime": 186.255,
        "transcript": "Qanruyutnek.",
        "translation": "About traditional wisdom."
    },
    "31": {
        "startTime": 187.215,
        "endTime": 199.265,
        "transcript": "Quyayaram nalliini tamakut pillermeggni bring up-aallermeggni tamana, qanrutkellermeggni watua",
        "translation": "During Thanksgiving, when they would bring that up, when they spoke about it"
    },
    "32": {
        "startTime": 200.855,
        "endTime": 207.485,
        "transcript": "Nallunrirtainun mat'um Quyayaram quyatengqerrnarqelliniakut ellaicetun Agayutmun.",
        "translation": "To those who know about Thanksgiving, we must give thank to God as they did."
    },
    "33": {
        "startTime": 207.485,
        "endTime": 211.88,
        "transcript": "Iciw' cat tamalkuita quyatekarkaulliniluki.",
        "translation": "You know, we must be thankful for everything."
    },
    "34": {
        "startTime": 211.88,
        "endTime": 218.38,
        "transcript": "Maaten maa-i kinguakun umyuacaulluku wii piaqa",
        "translation": "I realized afterwards when I pondered upon it"
    },
    "35": {
        "startTime": 218.725,
        "endTime": 227.755,
        "transcript": "Cat tamalkuita Agayutem aulukutai wangkutnun quyateknarqellinikput Agayutmun.",
        "translation": "We must thank God for all of the ways he cares for us."
    },
    "36": {
        "startTime": 228.675,
        "endTime": 237.305,
        "transcript": "Qaillun maa-i waten allrakuq ellirluku canek inerquutnek qanruyutnek-llu niitelallrusit anglillerpeni?",
        "translation": "Until this year, what kind admonishments and traditional wisdom did you hear when you were growing up?"
    },
    "37": {
        "startTime": 237.595,
        "endTime": 245.205,
        "transcript": "Anglillemni niitelallruunga tamatum Quyayaram avatiini",
        "translation": "When I was growing up, I used to hear things aside from Thanksgiving"
    },
    "38": {
        "startTime": 245.205,
        "endTime": 253.215,
        "transcript": "Wangkuta tau͡gaam arcqerluta iciw' Yup'igni ayuquciqellratnek au͡gkut ciuqlimta.",
        "translation": "But especially for us, you know, Yupiit, what our ancestors were like."
    },
    "39": {
        "startTime": 253.215,
        "endTime": 258.585,
        "transcript": "Atauciq waniwa qanruyun niitetulqa",
        "translation": "Here is one piece of traditional wisdom I used to hear"
    },
    "40": {
        "startTime": 260.365,
        "endTime": 268.635,
        "transcript": "Makuni waten KYUK-mi qanemcilrianek niicugniaqama",
        "translation": "When I listen to people telling stories like this here on KYUK"
    },
    "41": {
        "startTime": 268.635,
        "endTime": 274.075,
        "transcript": "Makunek ciulirnernek avani ayuqucillrat iciw' qanruyutellritnek",
        "translation": "What our ancestors were like back then, you know, their traditional wisdom"
    },
    "42": {
        "startTime": 274.57,
        "endTime": 285.22,
        "transcript": "Tua-i tang atauciq niitelalqa, niisngateksailkeka. Niicugninritlemni-w' tua-i niicugninritaqama iliini qanrutkelaryaaqellikiit.",
        "translation": "It seems that I haven't heard one thing I used to hear. They probably talk about when I wasn't listening, when I sometimes don't listen."
    },
    "43": {
        "startTime": 285.22,
        "endTime": 288.82,
        "transcript": "Maa-i atuqengaqsaguskiit mat'um nalliini.",
        "translation": "They've started doing it now."
    },
    "44": {
        "startTime": 288.825,
        "endTime": 301.055,
        "transcript": "Tua-i quyaunga waniwa tamana niitetulqa arcaqerluku, important-aalria, arcaqalria",
        "translation": "I am thankful especially for that important thing that I used to hear"
    },
    "45": {
        "startTime": 301.055,
        "endTime": 304.195,
        "transcript": "Tan'gaurlurnun wangkutnun arcaqerluni",
        "translation": "It's important for us boys"
    },
    "46": {
        "startTime": 304.42,
        "endTime": 314.82,
        "transcript": "Tan'gaurluullemteńi tamana tamaa-i qanruyun niitelalqa qanruteksugaqa waniwa, quyaunga-llu pillerpetegnek.",
        "translation": "I want to speak about that traditional wisdom I used to hear when we were boys, and I'm thankful that you asked."
    },
    "47": {
        "startTime": 316.315,
        "endTime": 321.115,
        "transcript": "Avani tan'gaurluq, qanruyutengqellruukut waten:",
        "translation": "A boy a long time ago, we had this piece of traditional wisdom:"
    },
    "48": {
        "startTime": 322.0,
        "endTime": 329.53,
        "transcript": "Tan'gaurluq-gguq man'a arcaqerluni calligtetuuq pinariaqami.",
        "translation": "They say that a boy especially scatters [out of the home] when it's time."
    },
    "49": {
        "startTime": 329.53,
        "endTime": 336.25,
        "transcript": "Cali-llu-gguq amlleret ilait, amlleret amllerni maa-i aturyaurrluku",
        "translation": "They also said that a lot of people have now started doing this"
    },
    "50": {
        "startTime": 336.255,
        "endTime": 343.145,
        "transcript": "Iciw' nunalgutkenrilkeḿeggnek aipangaqluteng tan'gaurluut.",
        "translation": "You know, boys marry people who are not from the same village."
    },
    "51": {
        "startTime": 343.145,
        "endTime": 346.44,
        "transcript": "Nunalinqiggluteng apqiitnek au͡gkut ciuqlimta.",
        "translation": "Our ancestors back then say they move to another village."
    },
    "52": {
        "startTime": 346.44,
        "endTime": 351.75,
        "transcript": "Tua-ll' tamana tamaa-i arcaqerluni qanruyun niitetulqa",
        "translation": "That that piece of wisdom I used to hear is important"
    },
    "53": {
        "startTime": 353.72,
        "endTime": 362.85,
        "transcript": "Nunalinqigeskuni tan'gaurluq, tan'gaurlurni wangkuta mat'umek arcaqerluta au͡gkut aarcirtullruitkut:",
        "translation": "If a boy moves to another village, they would especially warn us boys about this:"
    },
    "54": {
        "startTime": 363.46,
        "endTime": 376.6,
        "transcript": "Nunalinqigeskumta-gguq nunakenrilkemteńun tuani nunakenrilkemteńi ellangvikenrilkemteńi nunalinqigeskumta mulngakluta yuukilta.",
        "translation": "They said that if we move to another village aside from our own where we didn't grow up, we should live carefully if we move to another village."
    },
    "55": {
        "startTime": 376.605,
        "endTime": 385.44,
        "transcript": "Ukut nunat iciw' imumek nepliutekaatnek naucinritengnaqluta.",
        "translation": "We should try not to give, you know, sow discord in this village."
    },
    "56": {
        "startTime": 385.44,
        "endTime": 390.61,
        "transcript": "Iciw' arcaqerluku man'a maa-i inerquutekellruat:",
        "translation": "You know, this was the thing they especially admonished against:"
    },
    "57": {
        "startTime": 390.624,
        "endTime": 405.099,
        "transcript": "Ilaten, ilavet, yuullgutvet, egilrallgutvet imumek nepliutekaatnek naucinritengnaqkina tamaani nunakenrilkevni.",
        "translation": "Try not to sow discord among your peers, your fellow people, those who go through life with you there where it is not your [home] village."
    },
    "58": {
        "startTime": 405.105,
        "endTime": 414.868,
        "transcript": "Atam-gguq tuaten tamana atunrilkuvgu, naucilaquvet nepliutekamek nunakenrilkevni",
        "translation": "They said that if you do not heed that, if you give reason for commotion where it's not your [home] village"
    },
    "59": {
        "startTime": 415.23,
        "endTime": 428.63,
        "transcript": "Angayuqaagken yuarniaragket taukut nunat. \"Qaillun qanruteksaitellruat-qaa tan'gaurluullrani angayuqranek?\"",
        "translation": "That village will look for your parents. \"Did his parents not teach him when he was a boy?“"
    },
    "60": {
        "startTime": 429.274,
        "endTime": 437.774,
        "transcript": "Nalumni-gguq arcaqerluteng tamana qanrutkeciqaat naucitukuma nunakenrilkemni nepliutekaatnek.",
        "translation": "They said that they would especially talk about that without my knowledge if I give that village that is now my own reason for commotion."
    },
    "61": {
        "startTime": 437.781,
        "endTime": 449.018,
        "transcript": "Maa-i tang watuam nalliini tamana umyuarteq'lartua niitnanriryukluku qanruyun tamaaken ayagluni",
        "translation": "These days, I think that people don't hear that traditional wisdom since then"
    },
    "62": {
        "startTime": 449.031,
        "endTime": 457.631,
        "transcript": "Qanruyutngulleq aracqerluni yuk nunakenrilkeḿinun nunalinqigeskuni mulngakluni piarkaullra.",
        "translation": "The important traditional wisdom that if a person moves to another village aside from his own that he should be careful."
    },
    "63": {
        "startTime": 457.638,
        "endTime": 463.388,
        "transcript": "Ukut nunat nepliutekaatnek ayagnercinritengnaqluni.",
        "translation": "He should try not to sow discord in this village."
    },
    "64": {
        "startTime": 463.407,
        "endTime": 476.032,
        "transcript": "Wall' arcaqerluni pikenrilkeḿinek nunat ukut ilaksaguskengamini uitaviksaguskengami akluatnek iliita nalluani tegutesqevkenaku.",
        "translation": "Or more importantly, that he should take something of from the people that he's joined and lives with that is not his own without their knowledge."
    },
    "65": {
        "startTime": 476.038,
        "endTime": 479.976,
        "transcript": "Tamana arcaqerluku pillruat.",
        "translation": "They emphasized that."
    },
    "66": {
        "startTime": 480.927,
        "endTime": 500.328,
        "transcript": "Tua-i maa-i mat'um nalliini pulengtaq niitelartua nunakenrilkeḿeggnek nunalinqiggluteng neplircecilrianek taukunek tua-i-w' nunalinqiggvimeggnek.",
        "translation": "These days, I repeatedly hear about those who move to other villages that are not their own and sow discord in the village they moved into."
    },
    "67": {
        "startTime": 500.555,
        "endTime": 507.226,
        "transcript": "Tuamta-llu cali maa-i umyuartequrarqama ukut waniwa nunat Mamterillermiut",
        "translation": "Then when I think about these place here, Bethel"
    },
    "68": {
        "startTime": 510.286,
        "endTime": 518.244,
        "transcript": "Qanernarqutaitnek niipakayuicaaqellrianga, makut tau͡gaam tekitellriit naken nunanek allanek.",
        "translation": "I don't hear too much about those who need admonishing, except for these who come from some other villages."
    },
    "69": {
        "startTime": 518.267,
        "endTime": 523.281,
        "transcript": "Neplircecilriatun tamatumek ayagniriaqluteng.",
        "translation": "They sow discord."
    },
    "70": {
        "startTime": 523.289,
        "endTime": 538.716,
        "transcript": "Tua-i man'a qanruyun tamaani yuut ilaita atunge'rmegteggu, ilaita tau͡gaam atuyuitelliniamegteggu imumirpak iciw'?",
        "translation": "Because back then, though some people heeded that piece of traditional wisdom, however, there have always been some who did not heed it, you know?"
    },
    "71": {
        "startTime": 539.233,
        "endTime": 554.633,
        "transcript": "Yuk tan'gaurluq ayuqucirtuumallrung'e'rmi ayainanermini umyuangaqami tuaten piaqluni nunat nepliutekaatnek ellangvikenrilngermiki.",
        "translation": "Even though a person, a boy, was given instruction, when he has the idea as he goes, he sows discord in that village even though he didn't grow up there."
    },
    "72": {
        "startTime": 554.645,
        "endTime": 568.102,
        "transcript": "Arcaqerluni maa-i man'a au͡gkut ciulirnemta wangkuta wiinga niitetulqa aarcirtuutekellruat tan'gaurluq arcaqerluni iciw' nunalinqigtetuan.",
        "translation": "This was the important warning that I used to hear our elders say because boys especially, you know, move [when getting married]."
    },
    "73": {
        "startTime": 568.343,
        "endTime": 573.214,
        "transcript": "Tuamta-llu aipaa man'a arcaqerluni cali nepliutngulria:",
        "translation": "Then this other one that causes commotion is important:"
    },
    "74": {
        "startTime": 574.465,
        "endTime": 587.765,
        "transcript": "Tan'gaurluq, tan'gaurlurni wangkuta aipangkumta aipaput aipaqsaguskengaput iciw' kenkesqelluki",
        "translation": "A boy, when we boys get married, you know, they told us to love our spouses"
    },
    "75": {
        "startTime": 588.439,
        "endTime": 598.225,
        "transcript": "Arnat makut iciw' angutni, angutni wangkutni piniallruameng.",
        "translation": "Because women, you know, are weaker than men, we men."
    },
    "76": {
        "startTime": 598.236,
        "endTime": 611.55,
        "transcript": "Ilaita maa-i waten aipateng mulngakevkenaki piaqamegteki, umyuarteng-llu maligarrluku imumek callualuki piaqamegteki",
        "translation": "Now, when some are not careful with their spouses, and when they follow their idea to physically abuse them"
    },
    "77": {
        "startTime": 612.017,
        "endTime": 620.046,
        "transcript": "Wiinga murilkurallemni maa-i naulluutekaatnek ayagnirilriatun pilartut aiparmeng tungiinun.",
        "translation": "In my observation, it's like they start a sickness in their spouses."
    },
    "78": {
        "startTime": 620.412,
        "endTime": 625.312,
        "transcript": "Man'a-gguq pitekluku mulngaknarqaput aipaput.",
        "translation": "They say this is the reason we must be careful with our spouses."
    },
    "79": {
        "startTime": 626.159,
        "endTime": 641.502,
        "transcript": "Pitsaqa'artevkenani iciw' ciumteńi maaken ayakan umyuarniurutaitellerkarput tau͡gaam pitekluku aipamta tungiinun mulngakluki aipaqesqumaluki pilarai.",
        "translation": "Should they, you know, go before us, they tell them to be careful with their spouses so that they would not be filled with regret."
    },
    "80": {
        "startTime": 641.805,
        "endTime": 656.562,
        "transcript": "Mat'um nalliini niitelartua aipateng aipaqsaguskengateng nunalgutkenrilng'ermegteki",
        "translation": "These days, I hear that even though they take spouses that are not from their villages"
    },
    "81": {
        "startTime": 656.577,
        "endTime": 661.292,
        "transcript": "Allanek nunanek aipangenge'rmeng",
        "translation": "Though they take spouses from other villages"
    },
    "82": {
        "startTime": 662.279,
        "endTime": 675.634,
        "transcript": "Tamana aturyugnaunaku nanglluki aipateng nakmiin piaqluki kenkarkateng, ellmegcecicetun pitarrluki kenkarkateng.",
        "translation": "They do not heed that and beat their spouses whom they are supposed to love, whom they are supposed to love as themselves."
    },
    "83": {
        "startTime": 675.643,
        "endTime": 680.357,
        "transcript": "Iciw' maa-i mat'umun nugtara'arrlua pinaurqa.",
        "translation": "You know, let me move to this subject."
    },
    "84": {
        "startTime": 680.742,
        "endTime": 692.213,
        "transcript": "Kassuutellemteńi aipaput kenkarkauluki angraluta tua-i wangkucicetun pitarrluki.",
        "translation": "When we get marrid, we are supposed to love and agree with our spouses as ourselves."
    },
    "85": {
        "startTime": 692.462,
        "endTime": 700.776,
        "transcript": "Aipaput-gguq kenkekumteki wangkutnek kenkeciqukut, angutni wangkuta aipaitni.",
        "translation": "They said that if we love our spouses, we will love ourselves, we men, their spouses."
    },
    "86": {
        "startTime": 700.789,
        "endTime": 705.832,
        "transcript": "Maa-i tua-i arcaqerluteng ilaita atungaat mat'um naliini.",
        "translation": "They've started doing it, especially these days."
    },
    "87": {
        "startTime": 705.853,
        "endTime": 713.524,
        "transcript": "Aipateng mulngakevkenaki piaqamegteki naulluutekaatnek ayagnirluteng.",
        "translation": "When they are not careful with their spouses, they start sicknesses in them."
    },
    "88": {
        "startTime": 713.534,
        "endTime": 722.706,
        "transcript": "Maa-i-llu man'a naulluun amllermek imkusciigalnguq iinruilnguq spread-araqami.",
        "translation": "And this sickness cannot, you know, it has no medicine when it spreads."
    },
    "89": {
        "startTime": 722.723,
        "endTime": 729.408,
        "transcript": "Spread-arpailgan, sagpailgan tua-i maa-i yuungcaristet makut pituriyaaqaat.",
        "translation": "Before it spread, doctos now [treat] them."
    },
    "90": {
        "startTime": 729.418,
        "endTime": 738.432,
        "transcript": "Tau͡gaam waten wangkuta maa-i wii umyuartequrallemni",
        "translation": "But for us these days, as I ponder upon it"
    },
    "91": {
        "startTime": 738.449,
        "endTime": 743.235,
        "transcript": "Aipaput mulngakluki aipaqnarqelliniaput",
        "translation": "We must be careful with our spouses in our relationship"
    },
    "92": {
        "startTime": 743.252,
        "endTime": 757.594,
        "transcript": "Pitsaqa'artevkenateng iciw' tua-i wangkuta calekcagaluki callugluki callualuki pikumteki naulluutekaatnek ayagnirciqliniamta, ayagniuciiqelliniamteki.",
        "translation": "Because unintentionally, you know, if we treat them harshly and physically abuse them, we will start a sickness in them."
    },
    "93": {
        "startTime": 758.382,
        "endTime": 773.91,
        "transcript": "Tua-i maa-i man'a pitekluku arcaqerluku wiinga niiteqaqsailamku waten KYUK-ni ciulirnernek qanengssaaralrianek ayuqucirilrianek-wa avani niitelallermeggnek",
        "translation": "Especially for this reason now, since I've never heard it on KYUK when elders tell stories and give instructions on what they used to hear back then"
    },
    "94": {
        "startTime": 773.927,
        "endTime": 783.699,
        "transcript": "Maa-i umyuama nani pillerkaanek pilua qanrutkeqeryugluku pillruaqa",
        "translation": "Wanting to put my thought somewhere, I wanted to talk about it"
    },
    "95": {
        "startTime": 783.708,
        "endTime": 791.808,
        "transcript": "Pitsaqa'artevkenaku makut wani kingumteggun nangertellrianun niiskatgu umyuaqeqernayukluku.",
        "translation": "Just in case that the ones who will stand after us might remember it if they hear it."
    },
    "96": {
        "startTime": 791.82,
        "endTime": 797.577,
        "transcript": "Nangnermek camek quyacirpenek maa-i allrakumi qanqaqaa.",
        "translation": "Lastly, please say something you are thankful for this year."
    },
    "97": {
        "startTime": 797.596,
        "endTime": 803.853,
        "transcript": "Maa-i arcaqerlua quyatengqertua mat'umi waniwa Quyayarami tekitellemteńi",
        "translation": "Now, I have something I'm thankful for as we come to this Thanksgiving season."
    },
    "98": {
        "startTime": 803.871,
        "endTime": 816.798,
        "transcript": "Icivaq ava-i iralumi kiak August-aami ciungani naulluqrauratullruunga.",
        "translation": "Recently last summer in the month of August, I would be sick in the past."
    },
    "99": {
        "startTime": 816.812,
        "endTime": 821.212,
        "transcript": "Tua-i tunumnek piaqlua.",
        "translation": "My back would suffer."
    },
    "100": {
        "startTime": 821.233,
        "endTime": 835.718,
        "transcript": "Tau͡gaam ava-i August-aaq pit'eqerluku nutaan naulluullruunga tamana anaggluku, qaika-llu mermek agtaraqluni, nuyanka-llu mermek piaqluteng.",
        "translation": "But at the beginning of August, I was more sick then ever before, sweat gushing out of my body, and my hair would be [soaked] with sweat."
    },
    "101": {
        "startTime": 836.366,
        "endTime": 842.595,
        "transcript": "Cunawa teggalqunglliniama ilumkun qamaaggun.",
        "translation": "It turned out that I had gotten stones in my internal organs inside."
    },
    "102": {
        "startTime": 842.607,
        "endTime": 851.221,
        "transcript": "Tua-i nallunaitqapiarmek cirliqsartua hospital-aamun nataqiinrilkatnga taukunek.",
        "translation": "I would certainly have been incapacitated had they not found those in the hospital."
    },
    "103": {
        "startTime": 851.236,
        "endTime": 861.065,
        "transcript": "Waniwa tua-i tamana arcaqerluku quyatekaqa Agayutmun mat'um nalliini Quyayaram",
        "translation": "That is what I'm most thankful to God for during this Thanksgiving season"
    },
    "104": {
        "startTime": 861.081,
        "endTime": 871.752,
        "transcript": "Tuaten ayuqellrung'e'rma waniwa elliin man'a tekilluku, una tekilluku pivkaanga, unguvavkaanga.",
        "translation": "Because even though I was like that, he has allowed me to live to see this day, this day."
    },
    "105": {
        "startTime": 871.767,
        "endTime": 879.695,
        "transcript": "Tuarpiaq makut yuungcaristet Agayutem iciw' tua-i talliqngaki",
        "translation": "Because it truly seems that these doctors are [the work of] God's arms"
    },
    "106": {
        "startTime": 879.704,
        "endTime": 883.875,
        "transcript": "Wangkuta-llu piicautemta answer-aalaan tamakutgun.",
        "translation": "And because our prayers are answered through that."
    },
    "107": {
        "startTime": 883.89,
        "endTime": 893.433,
        "transcript": "Ilaput piicaulluki makutgun-llu tua-i yuungcaristetgun iinriurtetgun-llu ikayuumaluteng.",
        "translation": "We pray for those around us, and they are helped with these doctors and nurses."
    },
    "108": {
        "startTime": 893.456,
        "endTime": 904.499,
        "transcript": "Ava-i tuatequayaaqellruunga wiinga pilagtuqatallratni nangteqsiyaagama cakneq tuani naulluqertellemni.",
        "translation": "I had gone through that when they were going to perform surgery because I had been suffering so much when I was sick."
    },
    "109": {
        "startTime": 904.511,
        "endTime": 917.911,
        "transcript": "Tua-i atawauyartua waniwa ellangenrilkuma qavartellua pilagtuqataatnga tamana nangteqsiyaalqa umyuaqluku.",
        "translation": "It would have been good for me had I not awoken [alive] because they were going to anesthetize me for surgery because I was suffering so much."
    },
    "110": {
        "startTime": 917.918,
        "endTime": 921.546,
        "transcript": "Tua-i-ll' egmianun umyuaqa cimiqerluni.",
        "translation": "Then I immediately changed my mind."
    },
    "111": {
        "startTime": 922.563,
        "endTime": 935.549,
        "transcript": "Atak' tang wiinga Agayutmun tau͡gaam piicaglii, ukut-llu yuungcaristet iinriutet-llu tunlaki Agayutmun.",
        "translation": "Let me pray to God, and let me give these doctors and nurses to God."
    },
    "112": {
        "startTime": 935.566,
        "endTime": 943.68,
        "transcript": "Elliin wani waniwa piarkaunrilkuma ukutgun ikayuusqellua.",
        "translation": "If it was not my time, I asked him to help me through them."
    },
    "113": {
        "startTime": 943.695,
        "endTime": 952.666,
        "transcript": "Tua-i-ll' egmianun qavcinek qanerlua Agayutmun piicagtua waniwa uptellratni pilagtuqatarlua.",
        "translation": "Then I immediately said prayed about several things to God when they were preparing to perform surgery on me here."
    },
    "114": {
        "startTime": 954.049,
        "endTime": 965.149,
        "transcript": "\"Ukut wani,\" waten qanertua, nanilnguarmek piicagtua: \"Jesus-aaq tai-tai ilalirluta-llu.",
        "translation": "\"These people,\" I said this, praying a short prayer: \"Jesus come and be with us."
    },
    "115": {
        "startTime": 965.159,
        "endTime": 971.83,
        "transcript": "\"Ukut-llu yuungcaristet iinriutet-llu atawaqaasqekiki.\"",
        "translation": "\"And bless these doctors and nurses.\""
    },
    "116": {
        "startTime": 971.855,
        "endTime": 976.241,
        "transcript": "Tua-i tuaten pitalriamek piicallruunga.",
        "translation": "That was all I prayed for."
    },
    "117": {
        "startTime": 976.256,
        "endTime": 983.413,
        "transcript": "Tua-i-llu tamana kaigatka Agayutem niilluku.",
        "translation": "Then God heard my request."
    },
    "118": {
        "startTime": 983.415,
        "endTime": 989.029,
        "transcript": "Ukut-llu naulluutenka qamani antellrit",
        "translation": "And my ailments that they removed from inside"
    },
    "119": {
        "startTime": 989.052,
        "endTime": 1001.224,
        "transcript": "Kiugna aipaqa yuungcaristem qanrutliniluku taqngatnga tuani 80 or 90 teggalqunek-gguq au͡gautut ilumnek.",
        "translation": "The doctor told me wife in there when they were finished with me that they had removed 80 or 90 stones from my intenal organs."
    },
    "120": {
        "startTime": 1001.242,
        "endTime": 1006.128,
        "transcript": "Tua-i tang nanrallrukeka cakneq kinguani umyuamkun Agayun.",
        "translation": "Afterwards, I gave great praise to God in my mind."
    },
    "121": {
        "startTime": 1006.136,
        "endTime": 1013.593,
        "transcript": "Maa-i man'a arcaqerluku quyateka una Quyayaraq, Quyayaram uum nalliini.",
        "translation": "This is what I'm most thankful for in this Thanksgiving season."
    },
    "122": {
        "startTime": 1014.268,
        "endTime": 1015.211,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "123": {
        "startTime": 1015.218,
        "endTime": 1016.304,
        "transcript": "Yaa.",
        "translation": "You're welcome."
    },
    "124": {
        "startTime": 1017.01,
        "endTime": 1018.792,
        "transcript": "Anglill' teggal[qulillinivaa].",
        "translation": "There were so many stones."
    },
    "125": {
        "startTime": 1039.762,
        "endTime": 1041.444,
        "transcript": "[?Quuyuarniksaunii.]",
        "translation": "[?Don't tell me I smiled.]"
    }
};